import { render, staticRenderFns } from "./addNewTemplate.vue?vue&type=template&id=438f6f9c&scoped=true&"
import script from "./addNewTemplate.vue?vue&type=script&lang=ts&"
export * from "./addNewTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./addNewTemplate.vue?vue&type=style&index=0&id=438f6f9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f6f9c",
  null
  
)

export default component.exports